import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@sm/wds-react';

const EnterprisePackageCta = ({ small = false }) => {
  return (
    <Button
      className="sm-package__btn sm-package__btn--enterprise"
      href="/mp/contact-sales/"
      stretched
      data-testid="EnterprisePackageCta__Btn"
      size={small ? 'sm' : 'md'}
    >
      CONTACT US
    </Button>
  );
};

EnterprisePackageCta.propTypes = {
  small: PropTypes.bool,
};

EnterprisePackageCta.defaultProps = {
  small: false,
};

export default EnterprisePackageCta;
